import { Autocomplete, TextField } from "@mui/material"
import { ALL_GEO_TARGETS_TYPES, GEO_TARGETS_TYPES } from "form/model"
import { getGeoTargetTypeTranslation } from "form/tools/geo-targets-list"
import React from "react"

interface IGeoTargetTypeFilterProps {
  id: string
  label: string
  value: GEO_TARGETS_TYPES[]
  disabled?: boolean
  sx?: any
  onChange(newValue: GEO_TARGETS_TYPES[]): any
}

export const GeoTargetTypeFilter = React.memo(
  ({ id, label, disabled, value, onChange, sx }: IGeoTargetTypeFilterProps): JSX.Element => (
    <Autocomplete
      multiple
      sx={{ ...sx }}
      id={id}
      disabled={disabled}
      size="small"
      options={ALL_GEO_TARGETS_TYPES}
      getOptionLabel={type => getGeoTargetTypeTranslation(type)}
      value={value}
      filterSelectedOptions
      onChange={(_event, newValue) => onChange(newValue)}
      renderInput={params => <TextField {...params} label={label} />}
    />
  )
)
